import "../../../styles/accountSettingsComponent.scss";

import Icon, {iconColor, iconTypes} from "../../common/components/Icon.jsx";
import {Redirect, Route, Switch} from "react-router-dom";
import { TitleTab, TitleTabs } from "../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../common/components/ContentWrapper.jsx";
import Immutable from "seamless-immutable";
import LabelField from "../../common/components/LabelField.jsx";
import { Link } from "react-router-dom";
import {Localization} from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../common/components/ResponsiveRows.jsx";
import {default as SwitchComponent} from "../../common/components/Switch.jsx";
import TextField from "../../common/components/TextField.jsx";
import { getPropertyValue } from "../../common/util/changeUtils";

const ICON_STYLE = {
    marginLeft: "-6px"
};

class MyAccountComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            customer: null
        };

        this.onEdit = (change) => {
            this.setState({
                customer: {
                    ...(this.state.customer || this.props.customer),
                    ...change
                }
            });
        };

        this.onReset = (e) => {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                customer: null
            });
        };

        this.onSave = async (e) => {
            e.preventDefault();
            e.stopPropagation();

            const {
                validateEmail
            } = this.props;

            let disabled = false;
            disabled |= !this.state.customer;
            disabled |= this.props.customer.saving;

            if (disabled) {
                return;
            }

            disabled |= getPropertyValue(this.state.customer, "email") !== null && !validateEmail(getPropertyValue(this.state.customer, "email"));
            disabled |= getPropertyValue(this.state.customer, "email2") !== null && !validateEmail(getPropertyValue(this.state.customer, "email2"));

            if (!disabled) {
                await this.props.saveContactInformation(
                    getPropertyValue(this.state.customer, "contact"),
                    getPropertyValue(this.state.customer, "email"),
                    getPropertyValue(this.state.customer, "mobile"),
                    getPropertyValue(this.state.customer, "contact2"),
                    getPropertyValue(this.state.customer, "email2"),
                    getPropertyValue(this.state.customer, "mobile2")
                );
                
                this.setState({
                    customer: null
                });
            }
        };
    }

    componentDidMount() {
        this.props.getOwnCustomerWelcomeInfo();
    }

    render() {
        const {
            deviceType,
            localization,
            validateEmail
        } = this.props;

        const customer = this.state.customer || this.props.customer;

        let disabled = false;
        disabled |= getPropertyValue(customer, "email") !== null && !validateEmail(getPropertyValue(customer, "email"));
        disabled |= getPropertyValue(customer, "email2") !== null && !validateEmail(getPropertyValue(customer, "email2"));
        disabled |= customer.saving;

        return (
            <div className="my-account-component">
                <ResponsiveRows deviceType={deviceType}>
                    <ResponsiveColumn md={4}>
                        <div className="my-account-component-header">
                            <Icon type={iconTypes.account} style={ICON_STYLE}/> {localization.text("myAccount", "storeInformation")}
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "shopId")} isRequired={false} />
                            <TextField source={customer} property="customerId" onEdit={this.onEdit} locked={true} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "shopName")} isRequired={false} />
                            <TextField source={customer} property="customerName" onEdit={this.onEdit} locked={true} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "address")} isRequired={false} />
                            <TextField source={customer} property="streetAddress" onEdit={this.onEdit} locked={true} usingSubmit={true}/>
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn md={4}>
                        <div className="my-account-component-header">
                            <Icon type={iconTypes.chatBubble} style={ICON_STYLE}/> {localization.text("myAccount", "contact")}
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "name")} isRequired={true} />
                            <TextField source={customer} property="contact" onEdit={this.onEdit} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "email")} isRequired={true}/>
                            <TextField source={customer} property="email" onEdit={this.onEdit} validation={validateEmail} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "phoneNumber")} isRequired={true} />
                            <TextField source={customer} property="mobile" onEdit={this.onEdit} usingSubmit={true}/>
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn md={4}>
                        <div className="my-account-component-header">
                            <Icon type={iconTypes.chatBubble} style={ICON_STYLE}/> {localization.text("myAccount", "contact2")}
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "name")} isRequired={false} />
                            <TextField source={customer} property="contact2" onEdit={this.onEdit} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "email")} isRequired={false}/>
                            <TextField source={customer} property="email2" onEdit={this.onEdit} validation={validateEmail} usingSubmit={true}/>
                        </div>
                        <div className="default-margin-bottom">
                            <LabelField label={localization.text("myAccount", "phoneNumber")} isRequired={false} />
                            <TextField source={customer} property="mobile2" onEdit={this.onEdit} usingSubmit={true}/>
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn xs={12}>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={0} sm={0} md={3}>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={4} md={3}>
                                <Link className="btn block" to="/login/forgotPassword" style={{textAlign:"center"}}>{localization.text("myAccount", "changePassword")}</Link>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={4} md={3}>
                                <button className="btn block icon" disabled={!this.state.customer || this.state.customer.saving} onClick={this.onReset}><Icon type={iconTypes.x} color={iconColor.red}/>{localization.text("myAccount", "reset")}</button>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={4} md={3}>
                                <button className="btn block icon primary" disabled={disabled || !this.state.customer} onClick={this.onSave}>{localization.text("myAccount", "save")}</button>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </ResponsiveColumn>
                </ResponsiveRows>
            </div>
        );
    }
}

MyAccountComponent.propTypes = {
    customer: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    getOwnCustomerWelcomeInfo: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    saveContactInformation: PropTypes.func.isRequired,
    validateEmail: PropTypes.func.isRequired,
};


const createNotificationSetting = ({subscriptionType, web, email, sms}, property, localization, onChangeSubscription, disabled) => [
    <ResponsiveColumn key={`${subscriptionType}-1`} xs={6} md={9} className="centered-align-left subscription-header">{localization.text("customerSubscriptions", property)}</ResponsiveColumn>,
    // eslint-disable-next-line react/jsx-no-bind
    <ResponsiveColumn key={`${subscriptionType}-2`} xs={2} md={1} className="centered-with-border-left"><SwitchComponent checked={web} disabled={disabled} onChange={value => {
        onChangeSubscription(subscriptionType, "web", value);
    }}/></ResponsiveColumn>,
    // eslint-disable-next-line react/jsx-no-bind
    <ResponsiveColumn key={`${subscriptionType}-3`} xs={2} md={1} className="centered-with-border-left"><SwitchComponent checked={email}  disabled={disabled} onChange={value => {
        onChangeSubscription(subscriptionType, "email", value);
    }}/></ResponsiveColumn>,
    // eslint-disable-next-line react/jsx-no-bind
    <ResponsiveColumn key={`${subscriptionType}-4`} xs={2} md={1} className="centered-with-border-left"><SwitchComponent checked={sms} disabled={disabled} onChange={value => {
        onChangeSubscription(subscriptionType, "sms", value);
    }}/></ResponsiveColumn>
];

class NotificationsComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            customerSubscriptions: undefined
        };

        this.onChangeSubscription = (subscriptionType, contactType, value) => {
            const clone = Immutable(this.state.customerSubscriptions || this.props.customerSubscriptions).asMutable({deep: true});

            let sub = clone.subscriptions.find(s => s.subscriptionType === subscriptionType);
            if (!sub) {
                sub = {
                    subscriptionType,
                    web: false,
                    email: false,
                    sms: false
                };
                clone.subscriptions.push(sub);
            }

            sub[contactType] = value;

            this.setState({
                customerSubscriptions: Immutable(clone)
            });
        };

        this.onClickReset = e => {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                customerSubscriptions: undefined
            });
        };

        this.onClickSave = async e => {
            e.preventDefault();
            e.stopPropagation();

            const customerSubscriptions = this.state.customerSubscriptions;

            if (!customerSubscriptions) {
                return;
            }

            let validEmails = true;
            if (customerSubscriptions.mailAddressInvoice && customerSubscriptions.mailAddressInvoice.trim() !== "") {
                validEmails &= this.props.validateEmail(customerSubscriptions.mailAddressInvoice);
            }
            if (customerSubscriptions.mailAddressMonthReport && customerSubscriptions.mailAddressMonthReport.trim() !== "") {
                validEmails &= this.props.validateEmail(customerSubscriptions.mailAddressMonthReport);
            }
            if (customerSubscriptions.mailAddressDeliveryNote && customerSubscriptions.mailAddressDeliveryNote.trim() !== "") {
                validEmails &= this.props.validateEmail(customerSubscriptions.mailAddressDeliveryNote);
            }

            if (!validEmails) {
                return;
            }

            await this.props.saveCustomerSubscriptions(customerSubscriptions);

            this.setState({
                customerSubscriptions: undefined
            });
        };

        this.onEditEmail = change => {
            this.setState({
                customerSubscriptions: Immutable.merge(this.state.customerSubscriptions || this.props.customerSubscriptions, change)
            });
        };
    }

    componentDidMount() {
        this.props.getOwnCustomerSubscriptions();
    }

    render() {
        const {
            localization,
            validateEmail,
        } = this.props;

        const customerSubscriptions = this.state.customerSubscriptions || this.props.customerSubscriptions;

        const orderConfirmation = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 1) || {subscriptionType: 1};
        const autoCorrection = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 2) || {subscriptionType: 2};
        const orderChanged = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 3) || {subscriptionType: 3};
        const complaintConfirmation = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 4) || {subscriptionType: 4};
        const invoice = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 5) || {subscriptionType: 5};
        const monthReport = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 6) || {subscriptionType: 6};
        const deliveryNote = customerSubscriptions.subscriptions.find(s => s.subscriptionType === 8) || {subscriptionType: 8};

        let validEmails = true;
        if (customerSubscriptions.mailAddressInvoice && customerSubscriptions.mailAddressInvoice.trim() !== "") {
            validEmails &= validateEmail(customerSubscriptions.mailAddressInvoice);
        }
        if (customerSubscriptions.mailAddressMonthReport && customerSubscriptions.mailAddressMonthReport.trim() !== "") {
            validEmails &= validateEmail(customerSubscriptions.mailAddressMonthReport);
        }
        if (customerSubscriptions.mailAddressDeliveryNote && customerSubscriptions.mailAddressDeliveryNote.trim() !== "") {
            validEmails &= validateEmail(customerSubscriptions.mailAddressDeliveryNote);
        }

        return (
            <div className="customer-subscriptions-component">
                <div className="subscriptions">
                    <ResponsiveRows>
                        <ResponsiveColumn xs={6} md={9} className="centered-align-left header">
                            {localization.text("customerSubscriptions", "sendNotificationsFor")}
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={2} md={1} className="centered small-header">
                            <Icon type={iconTypes.notification}/> {localization.text("customerSubscriptions", "web")}
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={2} md={1} className="centered small-header">
                            <Icon type={iconTypes.message}/> {localization.text("customerSubscriptions", "email")}
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={2} md={1} className="centered small-header">
                            <Icon type={iconTypes.mobilePhone}/> {localization.text("customerSubscriptions", "sms")}
                        </ResponsiveColumn>

                        {createNotificationSetting(orderConfirmation, "orderConfirmation", localization, this.onChangeSubscription)}
                        {createNotificationSetting(autoCorrection, "autoCorrection", localization, this.onChangeSubscription)}
                        {createNotificationSetting(orderChanged, "orderChanged", localization, this.onChangeSubscription)}
                        {createNotificationSetting(complaintConfirmation, "complaintConfirmation", localization, this.onChangeSubscription)}
                        {createNotificationSetting(invoice, "invoice", localization, this.onChangeSubscription)}
                        {createNotificationSetting(monthReport, "monthReport", localization, this.onChangeSubscription)}
                        {createNotificationSetting(deliveryNote, "deliveryNote", localization, this.onChangeSubscription)}
                    </ResponsiveRows>
                </div>
                <div className="optional">
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12} md={4}>
                            <div className="default-margin-bottom">
                                <LabelField label={localization.text("customerSubscriptions", "mailAddressInvoice")} isRequired={false}/>
                                <TextField source={customerSubscriptions} property="mailAddressInvoice" onEdit={this.onEditEmail} validation={validateEmail} usingSubmit={true}/>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} md={4}>
                            <div className="default-margin-bottom">
                                <LabelField label={localization.text("customerSubscriptions", "mailAddressMonthReport")} isRequired={false}/>
                                <TextField source={customerSubscriptions} property="mailAddressMonthReport" onEdit={this.onEditEmail} validation={validateEmail} usingSubmit={true}/>
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={12} md={4}>
                            <div className="default-margin-bottom">
                                <LabelField label={localization.text("customerSubscriptions", "mailAddressDeliveryNote")} isRequired={false}/>
                                <TextField source={customerSubscriptions} property="mailAddressDeliveryNote" onEdit={this.onEditEmail} validation={validateEmail} usingSubmit={true}/>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
                <ResponsiveRows>
                    <ResponsiveColumn xs={12}>
                        <div className="my-account-component-buttons default-margin-bottom">
                            <button className="btn icon" disabled={!this.state.customerSubscriptions || this.state.customerSubscriptions.saving} onClick={this.onClickReset}><Icon type={iconTypes.x} color={iconColor.red}/>{localization.text("customerSubscriptions", "reset")}</button>
                            <button className="btn primary" disabled={!validEmails || !this.state.customerSubscriptions || this.state.customerSubscriptions.saving} onClick={this.onClickSave}>{localization.text("customerSubscriptions", "save")}</button>
                        </div>
                    </ResponsiveColumn>
                </ResponsiveRows>
            </div>
        );
    }
}

NotificationsComponent.propTypes = {
    customerSubscriptions: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    getOwnCustomerSubscriptions: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    saveCustomerSubscriptions: PropTypes.func.isRequired,
    validateEmail: PropTypes.func.isRequired,
};

const MARGIN_STYLE = {
    margin: "16px"
};

export default class AccountSettingsComponent extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            customer,
            customerSubscriptions,
            deviceType,
            getOwnCustomerWelcomeInfo,
            getOwnCustomerSubscriptions,
            height,
            localization,
            saveContactInformation,
            saveCustomerSubscriptions,
            validateEmail,
        } = this.props;

        const isTinyDevice = deviceType=="xs";

        return (
            <ContentWrapper height={height} paddingRight={true} extraStyles={this.extraStyles}>
                <div className="account-settings-component">
                    {!isTinyDevice && (
                        <div>
                            <div>
                                <TitleTabs>
                                    <TitleTab label={localization.text("myAccount", "myAccount")} url={"/account_settings/my_account"} deviceType={deviceType} />
                                    <TitleTab label={localization.text("myAccount", "notifications")} url={"/account_settings/subscriptions"} deviceType={deviceType} />
                                </TitleTabs>
                            </div>
                        </div>
                    )}
                    <div className="card-default" style={MARGIN_STYLE}>
                        <Switch>
                            {/* eslint-disable-next-line react/jsx-no-bind */}
                            <Route exact path="/account_settings/my_account" render={() => (
                                <MyAccountComponent
                                    deviceType={deviceType}
                                    localization={localization}
                                    getOwnCustomerWelcomeInfo={getOwnCustomerWelcomeInfo}
                                    customer={customer}
                                    saveContactInformation={saveContactInformation}
                                    validateEmail={validateEmail}
                                />
                            )}/>
                            {/* eslint-disable-next-line react/jsx-no-bind */}
                            <Route exact path="/account_settings/subscriptions" render={() => (
                                <NotificationsComponent
                                    deviceType={deviceType}
                                    localization={localization}
                                    getOwnCustomerSubscriptions={getOwnCustomerSubscriptions}
                                    customerSubscriptions={customerSubscriptions}
                                    saveCustomerSubscriptions={saveCustomerSubscriptions}
                                    validateEmail={validateEmail}
                                />
                            )}/>
                            <Redirect push={false} to="/account_settings/my_account"/>
                        </Switch>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

AccountSettingsComponent.propTypes = {
    customer: PropTypes.object.isRequired,
    customerSubscriptions: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    getOwnCustomerWelcomeInfo: PropTypes.func.isRequired,
    getOwnCustomerSubscriptions: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    localization: Localization.propTypes.isRequired,
    saveContactInformation: PropTypes.func.isRequired,
    saveCustomerSubscriptions: PropTypes.func.isRequired,
    validateEmail: PropTypes.func.isRequired,
};